export const getObjectCookie = (name: string) => {
  const nameEQ = `${name}=`
  const ca = document?.cookie?.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)))
      } catch (e) {
        return null // Handle JSON parsing error
      }
    }
  }
  return null
}
